import { IconMapPin, IconTruckDelivery } from '@tabler/icons';

import {
  Button,
  Modal,
  ModalBody,
  ModalDescription,
  ModalFooter,
  ModalHeader,
  ModalTitle,
  Timeline,
} from '#root/components/ui';
import styles from './shopperShippingDialog.module.scss';

interface ShopperShippingDialogProps {
  open: boolean;
  onClose: () => void;
}

const STEPS = [
  'El viajero entrega tu pedido en una oficina de Mail Boxes ETC en Lima (Miraflores, San Isidro o Surco).',
  'Te avisamos para que confirmes la dirección de envío en Mis Envíos.',
  'Cuando esté listo, pagas el envío (embalaje, flete y seguro) y lo despachamos.',
  'OLVA lo entrega en tu dirección.',
];

/**
 * Qué pasa con un pedido con Envío Nacional, para el comprador: lo justo para que no le queden
 * dudas. Lo abre el badge "Envío Nacional" de Mis Pedidos (regular y ONE) y del detalle del
 * pedido. El viajero tiene los suyos, con oficinas e indicaciones: `components/ProvinceDialog`.
 */
const ShopperShippingDialog = ({ open, onClose }: ShopperShippingDialogProps) => (
  <Modal open={open} onClose={onClose} size="sm">
    {/* Ámbar: la identidad del badge "Envío Nacional" */}
    <ModalHeader icon={<IconTruckDelivery />} tone="warning">
      <ModalTitle>Tu pedido con Envío Nacional</ModalTitle>
      <ModalDescription>Te lo enviamos con OLVA a Lima o provincias.</ModalDescription>
    </ModalHeader>
    <ModalBody>
      <Timeline items={STEPS} />
      <section className={styles.pickup}>
        <h3 className={styles.heading}>
          <IconMapPin size={18} aria-hidden="true" /> ¿Prefieres recogerlo?
        </h3>
        <p className={styles.text}>
          Elige “Recoger en persona” en Mis Envíos y recógelo <strong>sin costo</strong> en esa
          oficina, hasta <strong>7 días</strong> después de que el viajero lo entregue.
        </p>
      </section>
    </ModalBody>
    <ModalFooter>
      <Button onClick={onClose}>Entendido</Button>
    </ModalFooter>
  </Modal>
);

export default ShopperShippingDialog;
